import { MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-documents-examples-dialog',
  templateUrl: './upload-documents-examples-dialog.component.html',
  styleUrls: ['./upload-documents-examples-dialog.component.scss']
})
export class UploadDocumentsExamplesDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UploadDocumentsExamplesDialogComponent>
  ) { }

  ngOnInit(): void { }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
}
